if (!customElements.get('page-popup')) {
  customElements.define(
    'page-popup',
    class PagePopup extends HTMLElement {
      constructor() {
        super();

        this.link = this.querySelector('a');
        this.clickHandler = this.handleClick.bind(this);
      }

      connectedCallback() {
        if (!this.link) return;

        this.link.addEventListener('click', this.clickHandler);
        this.schedulePreload();
      }

      disconnectedCallback() {
        this.link?.removeEventListener('click', this.clickHandler);
      }

      get modal() {
        return document.querySelector(this.getAttribute('data-modal'));
      }

      // Warm the modal content on idle time after the page has finished
      // loading, so opening the popup is instant. A failed preload is
      // silent — clicking retries and falls back to navigation.
      schedulePreload() {
        const start = () => {
          const idle = window.requestIdleCallback || ((callback) => setTimeout(callback, 2000));
          idle(() => this.loadContent().catch(() => {}));
        };

        if (document.readyState === 'complete') {
          start();
        } else {
          window.addEventListener('load', start, { once: true });
        }
      }

      handleClick(event) {
        const modal = this.modal;

        // Fall back to normal navigation when the modal is unavailable
        if (!modal || typeof modal.show !== 'function') return;

        event.preventDefault();
        modal.show(this.link);

        this.loadContent().catch(() => {
          // Content could not be fetched — navigate to the page instead
          modal.hide();
          window.location.href = this.link.href;
        });
      }

      loadContent() {
        const container = this.modal?.querySelector('[data-page-popup-content]');
        if (!container) return Promise.reject(new Error('Popup content container not found'));
        if (container.dataset.loaded === 'true') return Promise.resolve();
        if (this.pendingLoad) return this.pendingLoad;

        this.pendingLoad = fetch(container.dataset.pageUrl)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const main = html.querySelector('#MainContent');
            if (!main) throw new Error('Main content not found');

            container.dataset.loaded = 'true';
            container.innerHTML = main.innerHTML;
          })
          .finally(() => {
            this.pendingLoad = null;
          });

        return this.pendingLoad;
      }
    },
  );
}
